import React, { useEffect } from "react";
import TermsAndConditions from "../LegalDocumentPages/TermsAndConditions";

const IDFTermsOfUse: React.FunctionComponent<{ dialogId: string }> = (props) => {
    useEffect(() => {
        document.querySelector<any>(`[aria-labelledby=${props.dialogId}-title]`)!.classList.add("width-lg");
    }, []);

    return (
        <React.Fragment>
            <div className="dialog-header">
                <h2>Terms of Use</h2>
            </div>
            <div className="large-dialog-scroll dialog-body">
                <TermsAndConditions />
            </div>
        </React.Fragment>
    );
};

export default IDFTermsOfUse;
